import Vue from 'vue'
import Router from 'vue-router'
import Ouvidoria from './views/Ouvidoria.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Ouvidoria',
      component: Ouvidoria
    },
  ]
})
